import type { HydraulicSystem } from '../system'
import type { Scenarios } from './schema'

export const DEFAULT_BASE_SCENARIO_ID = 'base'

/** A fresh single-Base scenario tree (no overrides). */
export function defaultScenarios(): Scenarios {
  return {
    active_id: DEFAULT_BASE_SCENARIO_ID,
    nodes: [{ id: DEFAULT_BASE_SCENARIO_ID, name: 'Base', parent_id: null, overrides: [] }],
  }
}

/**
 * Guarantee `system.scenarios` exists. Legacy systems (and freshly built ones)
 * have no scenario tree; this backfills a single Base node. Idempotent: a system
 * that already has scenarios is returned by the SAME reference (no churn).
 */
export function ensureScenarios(system: HydraulicSystem): HydraulicSystem {
  if (system.scenarios) return system
  return { ...system, scenarios: defaultScenarios() }
}
